import React, {useEffect, useState, useRef} from 'react'
import { GrUpdate } from "react-icons/gr";
import isEqual from 'lodash/isEqual'; 
import VisDiv from '../frontend_components/VisDiv';
import {generatedOfferDoc} from '../gestioneDatabase/Docs';
import {FiSave} from 'react-icons/fi'
import CheckIcon from '../frontend_components/CheckIcon';
import { ViewProduct } from './EditableProduct';
import useMediaQuery from '../../hooks/useMediaQuery';
import { EditableProductHeader } from './EditableProducts';
import TestButton from '../frontend_components/TestButton';
import useDebounce from '../../hooks/useDebounce';


const UpdateOfferFromRegister = ({reportData, offerData, addFields = () => {}}) => {
      
    const [viewToAdd, setViewToAdd] = useState(false)


    const commonStyle = (edit) => { 
      
      return (
      {
        display:"flex", 
        alignItems:"center", 
        fontSize:"12px", 
        justifyContent:"center", 
        width: edit ? "160px":"85px", 
        minWidth: edit ? "160px":"85px", 
        padding: "20px", 
        borderRight: 1, 
        borderRightColor: "#d1c5c5", 
        borderRightStyle: "dotted" 
      }
        )}
    const screenSizeDesktop = useMediaQuery("(min-width: 1540px)")
        

    const sortBySortKey = ( a, b ) => {

        return a?.sortKey?.toString()?.localeCompare(b?.sortKey?.toString(), undefined, {
    
          numeric: true,
          sensitivity: 'base'
        })}
    
    const reportDataWithKey = !Array.isArray(reportData) ? [] : reportData?.map?.((item)=>{
      return ({
        ...item,
        sortKey: `${item?.customerProductId}-${item?.deviceId}-${item?.nonConformityId}`

      })
    })

    const compareObject = (obj = {}) =>{ 
        const {customerProductId, nonConformityId, deviceId, offerPropertyId, deviceFamilyId, } = obj
        return ( {customerProductId, offerPropertyId, deviceId, nonConformityId, deviceFamilyId, sortKey: `${customerProductId}-${deviceId}-${nonConformityId}`}) 
      } 
      const compareArray = (array=[]) => {
        return array?.map?.((x)=>compareObject(x))?.sort(sortBySortKey)
      }
      const filteredOfferData = !Array.isArray(offerData) ? [] : offerData?.filter?.((x)=>!x?.isManual && !x?.addedLocation)
      //const manualOrAddedLocationOfferData = !Array.isArray(offerData) ? [] : offerData?.filter?.((x)=>x?.isManual || x?.addedLocation)

      const checkData = {
        reportAndOfferAreEqual: isEqual(compareArray(reportData), compareArray(filteredOfferData)),
        reportData,
        compareReportData: compareArray(reportData),
        offerData,
        compareOfferData: compareArray(filteredOfferData)
      }
      const newOfferFieldsToAdd = (checkData) => {

        return checkData?.compareReportData?.map?.((item)=>{
          const findItem = checkData?.compareOfferData?.find?.((x)=>x?.sortKey == item?.sortKey)
          const getFullObject = reportDataWithKey?.find?.((x)=>x?.sortKey == item?.sortKey)
/*           console.log("Processing item:", {
            item,
            findItem,
            getFullObject,
            sortKey: item?.sortKey
          }) */
         if(!findItem && getFullObject?.registerId == "f7a3a346-5880-4c15-9133-45e4936a609d"){
/*             console.log("Adding new fields:", {
              reportData: checkData?.compareReportData,
              offerData: checkData?.compareOfferData,
              findItem,
              item,
              getFullObject,
              reportDataWithKey
            }) */
          } 
          if(!findItem) return getFullObject
          return undefined
        })?.filter?.((x)=>x)
      }

      const getObjectDiff = (obj1, obj2) => {
            const diff = Object.keys(obj1).reduce((result, key) => {
                if (!obj2.hasOwnProperty(key)) {
                    result.push(key);
                } else if (isEqual(obj1[key], obj2[key])) {
                    const resultKeyIndex = result.indexOf(key);
                    result.splice(resultKeyIndex, 1);
                }
                return result;
            }, Object.keys(obj2));
        
            return diff;
        }

      const [addedOfferFields, setAddedOfferFields] = useState(newOfferFieldsToAdd(checkData))
      const addedOfferFieldsRef = useRef(addedOfferFields)
      
      // Keep ref in sync with state
      useEffect(() => {
        addedOfferFieldsRef.current = addedOfferFields
      }, [addedOfferFields])

      useEffect(() => {
        if(!checkData){
          setAddedOfferFields(newOfferFieldsToAdd(checkData))
        }
      }, [checkData])
    
      const [updateOfferFromRegister] = useDebounce((e) => {
        e.stopPropagation()
        // Use ref to get the latest value
        addFields(addedOfferFieldsRef.current)
        setViewToAdd(false)
      }, 1000)

  return (
    <div>
        <VisDiv rules={[!checkData?.reportAndOfferAreEqual]} className='round-back-button' style={{backgroundColor:"white", display:"flex", flexDirection:"column"}} onClick={(e) => {e.stopPropagation(); setViewToAdd(!viewToAdd)}}> 
          <GrUpdate fontSize={30} />
        </VisDiv>
        <TestButton buttonId={"e2poekp2kep2o3kepo23ke"} message={"updateOfferFromRegister"} consoleData={{checkData, addedOfferFields, newOfferFieldsToAdd: newOfferFieldsToAdd(checkData), objectDiff: getObjectDiff(checkData?.compareOfferData, checkData?.compareReportData)}}/>
        <VisDiv rules={[viewToAdd]}>
        {
            !Array.isArray(newOfferFieldsToAdd(checkData)) ? [] : newOfferFieldsToAdd(checkData)?.map?.((item, index)=>{
              return (
                <AddProductPin
                  commonStyle={commonStyle}
                  key={index}
                  data={{
                    screenSizeDesktop,
                    offerField: item,
                    addedOfferFields,
                    setAddedOfferFields: setAddedOfferFields
                  }}
                />
              )})

          }
          <button type='button' className='pdf-button' style={{backgroundColor:"green", display: "flex", alignItems:"center"}} onClick={updateOfferFromRegister}>
              <FiSave            
              size={15}
              color={"white"}/>
              <h3 style={{color:"white", marginLeft:"10px"}}>SALVA</h3>
          </button>
        </VisDiv>
    </div>
  )
}

export default UpdateOfferFromRegister

export const AddProductPin = ({data = {}, commonStyle}) => {
 const {offerField, addedOfferFields, setAddedOfferFields, screenSizeDesktop} = data
 const isInAddedOfferFields = addedOfferFields?.some?.((x)=>x?.sortKey == offerField?.sortKey)
 const onPinClick = (e) => {
   e.stopPropagation()
   console.log("ON PIN CLICK", offerField)
   if(isInAddedOfferFields){
     setAddedOfferFields(addedOfferFields?.filter?.((x)=>x?.sortKey !== offerField?.sortKey))
   } else {
     setAddedOfferFields([...addedOfferFields, offerField])
   }
  }
 
  return (
              <div onClick={onPinClick} style={{display:"flex", alignItems:"center", margin:"10px", padding:"2px", borderBottom:"1px solid #CCC", borderTop:"1px solid #CCC"}}>
                  <CheckIcon
                        status={isInAddedOfferFields}
                  />
                  <div style={{marginLeft:"10px", width:"100%"}}>
                     <EditableProductHeader commonStyle={commonStyle} edit={false}/>
                    <h3>
                      {offerField?.customerProduct}
                    </h3>
                 
                    <ViewProduct commonStyle={commonStyle} data={{pr: offerField, screenSizeDesktop}} />
                  </div>
                 
                </div>
  )
}
